import { render, staticRenderFns } from "./menu-timeline.vue?vue&type=template&id=620fb2db&"
import script from "./menu-timeline.vue?vue&type=script&lang=js&"
export * from "./menu-timeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports